// Dynamic manifest utility for client-side generation
export const generateDynamicManifest = (currentPath: string = window.location.pathname): Record<string, unknown> => {
  // Get the base URL for absolute paths
  const baseUrl = window.location.origin;

  const baseManifest = {
    categories: ['business', 'health', 'safety', 'productivity'],
    name: 'Vatix Workspace',
    short_name: 'Vatix Workspace',
    description: 'Allows for offline access to Vatix forms',

    id: `${baseUrl}${currentPath}`,
    scope: `${baseUrl}/`,
    start_url: `${baseUrl}${currentPath}`, // Dynamic based on current page with absolute URL

    display: 'standalone',
    theme_color: '#4285F4',
    background_color: '#FFFFFF',
    capture_links: 'none',
    orientation: 'portrait-primary',
    lang: 'en',
    dir: 'ltr',
    screenshots: [
      {
        src: `${baseUrl}/screenshots/desktop-screenshot.avif`,
        sizes: '1240x820',
        type: 'image/avif',
        form_factor: 'wide',
        label: 'Desktop view of Vatix Workspace',
      },
      {
        src: `${baseUrl}/screenshots/mobile-screenshot.png`,
        sizes: '400x880',
        type: 'image/png',
        form_factor: 'narrow',
        label: 'Mobile view of Vatix Workspace',
      },
    ],
    icons: [
      {
        src: `${baseUrl}/favicons/android-icon-36x36.png`,
        sizes: '36x36',
        type: 'image/png',
        purpose: 'any',
      },
      {
        src: `${baseUrl}/favicons/android-icon-48x48.png`,
        sizes: '48x48',
        type: 'image/png',
        purpose: 'any',
      },
      {
        src: `${baseUrl}/favicons/android-icon-72x72.png`,
        sizes: '72x72',
        type: 'image/png',
        purpose: 'any',
      },
      {
        src: `${baseUrl}/favicons/android-icon-96x96.png`,
        sizes: '96x96',
        type: 'image/png',
        purpose: 'any',
      },
      {
        src: `${baseUrl}/favicons/android-icon-144x144.png`,
        sizes: '144x144',
        type: 'image/png',
        purpose: 'any',
      },
      {
        src: `${baseUrl}/favicons/android-icon-192x192.png`,
        sizes: '192x192',
        type: 'image/png',
        purpose: 'any',
      },
      {
        src: `${baseUrl}/favicons/android-icon-192x192.png`,
        sizes: '192x192',
        type: 'image/png',
        purpose: 'maskable',
      },
      {
        src: `${baseUrl}/favicons/maskable_icon_x512.png`,
        purpose: 'maskable',
        sizes: '512x512',
        type: 'image/png',
      },
      {
        src: `${baseUrl}/favicons/apple-icon-180x180.png`,
        sizes: '180x180',
        type: 'image/png',
        purpose: 'any',
      },
      {
        src: `${baseUrl}/favicons/favicon-96x96.png`,
        sizes: '96x96',
        type: 'image/png',
        purpose: 'any',
      },
      {
        src: `${baseUrl}/favicons/favicon-32x32.png`,
        sizes: '32x32',
        type: 'image/png',
        purpose: 'any',
      },
    ],
  };

  return baseManifest;
};

// Function to update the manifest link in the document
export const updateManifestLink = (currentPath: string): void => {
  // Remove existing manifest link
  const existingLink = document.querySelector('link[rel="manifest"]');
  if (existingLink) {
    existingLink.remove();
  }

  // Create new manifest link with dynamic content
  const manifestLink = document.createElement('link');
  manifestLink.rel = 'manifest';
  manifestLink.href = `data:application/json,${encodeURIComponent(
    JSON.stringify(generateDynamicManifest(currentPath))
  )}`;

  document.head.appendChild(manifestLink);
};
